import "./styles/vendor";
import "./styles/app.css";

import "./components/uploader";
import "./components/placeholder";
import "./components/editor";
import "./components/downloader";
import "./components/rejected";

import { EventBus, Events } from "./components/eventBus";

document.addEventListener("DOMContentLoaded", function (event) {
  EventBus.emit(Events.APP_LOADED);
  // EventBus.emit(Events.PDF_UPLOADED, {
  //   // url: "https://support.qwil.io/hc/article_attachments/11228615374237",
  //   url: "http://192.168.1.241:3000/0a.pdf",
  //   filename: "fake.pdf",
  // });
  // setTimeout(function () {
  //   EventBus.emit(Events.SHOW_PREVIEW);
  // }, 1500);

  // EventBus.emit(Events.EXPORT_DONE, { data: "" });
});
